import { render } from "./cutePets.vue?vue&type=template&id=f1f22ed6&scoped=true"
import script from "./cutePets.vue?vue&type=script&lang=js"
export * from "./cutePets.vue?vue&type=script&lang=js"

import "./cutePets.vue?vue&type=style&index=0&id=f1f22ed6&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f22ed6"]])

export default __exports__